import React, { useMemo } from "react";
import { Row, Col, Modal } from "antd";
import { Pie } from "@ant-design/plots";
import styled from "@emotion/styled";
import InfoIcon from "@mui/icons-material/Info";
import { getLeaveCategoryList } from "redux/selectors";
import { connect } from "react-redux";
import moment from "moment";

const StyledChartContainer = styled.div`
  border: solid 1px #9b9b9b6b;
  border-radius: 3px;
  padding: 20px;
  margin-bottom: 15px;
  .styledHeader {
    display: flex;
    align-items: center;
  }
  @media (max-width: 425px) {
    padding: 5px;
    .styledHeader {
      flex-direction: column;
      align-items: flex-start;
      margin-bottom: 10px;
    }
  }

  .legends {
    display: flex;
    flex-direction: column;
    padding-top: 2rem;
    padding-left: 5px;

    .legend-item {
      display: flex;
      align-items: center;
      margin-bottom: 8px;
      gap: 2px;

      span {
        margin-left: 8px;
      }

      .data {
        margin-left: auto;
        margin-right: 5px;
      }
    }
  }
`;

const StyledTitle = styled.div`
  font-size: 1.02rem;
  font-weight: 600;
  color: #141414;
  margin-right: auto;
`;

const StyledColorBox = styled.span`
  ${({ color }) => color && `background: ${color};`}
  padding: 0px 8px;
  margin-right: 10px;
  border-radius: 5px;
  width: 15px;
  height: 15px;
`;

function getRandomColor() {
  const getHighComponent = () =>
    Math.floor(Math.random() * 156 + 100)
      .toString(16)
      .padStart(2, "0");
  const getLowComponent = () =>
    Math.floor(Math.random() * 100)
      .toString(16)
      .padStart(2, "0");

  const components = [
    getHighComponent(),
    getHighComponent(),
    getLowComponent(),
  ];

  for (let i = components.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [components[i], components[j]] = [components[j], components[i]];
  }

  return `#${components.join("")}`;
}

function lightenColor(color, percent) {
  const num = parseInt(color.slice(1), 16),
    amt = Math.round(2.55 * percent),
    R = (num >> 16) + amt,
    G = ((num >> 8) & 0x00ff) + amt,
    B = (num & 0x0000ff) + amt;
  return `#${(
    0x1000000 +
    (R < 255 ? (R < 1 ? 0 : R) : 255) * 0x10000 +
    (G < 255 ? (G < 1 ? 0 : G) : 255) * 0x100 +
    (B < 255 ? (B < 1 ? 0 : B) : 255)
  )
    .toString(16)
    .slice(1)}`;
}

function LeaveDonutChart({
  iconName,
  title,
  data,
  leaveId,
  leaveCategoryList,
}) {
  console.log("leaveId1-->", leaveId);
  console.log("title-->,", title);
  console.log("value-->", data);
  // Generate colors once using useMemo
  console.log(
    "findexpiryDate--->",
    // leaveCategoryList
    leaveCategoryList?.find(
      (item) => String(item?.leave_category_id) === String(leaveId)
    )?.rollout
  );
  const [open, setOpen] = React.useState(false);
  const [availableColor, consumedColor] = useMemo(() => {
    const baseColor = getRandomColor();
    const lighterColor = lightenColor(baseColor, 30);
    return [baseColor, lighterColor];
  }, []); // Empty dependency array ensures colors are generated only once.

  // ...existing code...
  const carryForwardForId = useMemo(() => {
    if (!data || !leaveId) return null;

    // Case A: data is chart-array like [{type, value, carryforward}, ...]
    if (
      Array.isArray(data) &&
      data.some((d) => d && d.carryforward !== undefined)
    ) {
      return (
        data.find((d) => d && d.carryforward !== undefined)?.carryforward ??
        null
      );
    }

    if (Array.isArray(data)) {
      for (const item of data) {
        if (item && typeof item === "object") {
          for (const key of Object.keys(item)) {
            const arr = item[key];
            if (Array.isArray(arr)) {
              // if the third element matches leaveId, return the carryforward from the available item (index 0)
              if (String(arr[2]) === String(leaveId)) {
                return arr[0]?.carryforward ?? null;
              }
            }
          }
        }
      }
    }

    return null;
  }, [data, leaveId]);
  // ...existing code...
  console.log("carryForwardForId-->", carryForwardForId);
  const config = {
    width: 120,
    height: 120,
    appendPadding: 6,
    data,
    angleField: "value",
    colorField: "type",
    radius: 1,
    innerRadius: 0.7,
    color: leaveId === "5" ? [consumedColor] : [availableColor, consumedColor],
    tooltip: false,
    legend: false,
    label: false,
    statistic: {
      title: false,
      content: {
        style: { fontSize: 13 },
        content:
          leaveId === "5"
            ? `${data[1]?.value}`
            : `${data[1]?.value}/${data[0]?.value}`,
      },
    },
  };

  return (
    <>
      <StyledChartContainer>
        <Row>
          <Col span={24}>
            <div className="styledHeader">
              <StyledTitle>{title}</StyledTitle>
              {leaveCategoryList?.find(
                (item) => String(item?.leave_category_id) === String(leaveId)
              )?.rollout === "Yes" && (
                <div
                  onClick={(e) => {
                    e.stopPropagation();
                    e.preventDefault();
                    // setOpen(true);
                  }}
                >
                  <span>
                    <InfoIcon
                      sx={{
                        color: "#1976d2",
                        fontSize: "20px",
                        marginRight: "8px",
                        cursor: "pointer",
                      }}
                      onClick={(e) => {
                        setOpen(true);
                      }}
                    />
                  </span>

                  {/* Carry Forward Days Display */}
                  {data?.[0]?.carryforward != null && (
                    <span>
                      CF: <b>{data[0].carryforward}</b> Days
                    </span>
                  )}
                </div>
              )}
            </div>
          </Col>
          <Col xs={24} sm={12}>
            <Pie {...config} />
          </Col>
          <Col xs={24} sm={12} className="legends">
            {leaveId !== "5" && (
              <div className="legend-item">
                <StyledColorBox color={availableColor}></StyledColorBox>
                <span>Available</span>
                <span className="data">{data[0]?.value}</span>
              </div>
            )}

            <div className="legend-item">
              <StyledColorBox color={consumedColor}></StyledColorBox>
              <span>Consumed</span>
              <span className="data">{data[1]?.value}</span>
            </div>
          </Col>
        </Row>
      </StyledChartContainer>

      <Modal
        // title={
        //   <span style={{ fontSize: "20px", fontWeight: 500, color: "#262626" }}>
        //     Carry – Forward Leave (CF)
        //   </span>
        // }
        header={null}
        open={open}
        onCancel={(e) => {
          setOpen(false);
          e.stopPropagation();
          e.preventDefault();
        }}
        footer={null}
        width={600}
        // closeIcon={
        //   <span style={{ fontSize: "20px", color: "#8c8c8c" }}>×</span>
        // }
      >
        <>
          <span style={{ fontSize: "20px", fontWeight: 500, color: "#262626" }}>
            Carry – Forward Leave (CF)
          </span>
          <div style={{ padding: "12px 0" }}>
            <p
              style={{
                color: "#8c8c8c",
                fontSize: "15px",
                lineHeight: "1.7",
                marginBottom: "20px",
              }}
            >
              Carry-Forward leave represents last year's unused leave brought
              into this year. These days are available only for a limited time
              and will be removed once the validity period ends.
            </p>

            <p
              style={{
                color: "#262626",
                fontSize: "15px",
                fontWeight: 500,
                margin: 0,
              }}
            >
              Validity till:{" "}
              {(() => {
                const expiryMonth = leaveCategoryList?.find(
                  (item) => String(item?.leave_category_id) === String(leaveId)
                )?.expiry_date;
                console.log("expiryMonth-->", expiryMonth);

                if (!expiryMonth) return "-";

                // Convert Month to date and get last day
                return moment(expiryMonth, "MMMM")
                  .endOf("month")
                  .format("DD MMMM YYYY");
              })()}
              <span style={{ color: "#8c8c8c", fontWeight: 400 }}></span>
            </p>
          </div>
        </>
      </Modal>
    </>
  );
}

// export default LeaveDonutChart;
const mapStateToProps = (state) => ({
  leaveCategoryList: getLeaveCategoryList(state),
});

export default connect(mapStateToProps, null)(LeaveDonutChart);
